"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
var PHONE_NUMBER_REGEXP = /^(\+?[-_/() ]*(\d[-_/() ]*?){3,15})$/;
exports.phoneNumberValidator = {
    name: 'phoneNumber',
    validation: function (value) {
        if (utils_1.isEmpty(value)) {
            return true;
        }
        if (!utils_1.isString(value) || value.length > 20) {
            return false;
        }
        return PHONE_NUMBER_REGEXP.test(value);
    },
};
//# sourceMappingURL=PhoneNumberValidator.js.map